var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 6.73459 23.2654 0 15 0C6.73459 0 0 6.73459 0 15C0 23.2654 6.73459 30 15 30C23.2654 30 30 23.2654 30 15Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H11C8.37812 6 6 8.40579 6 11V19C6 21.5942 8.37812 24 11 24H20C22.6219 24 25 21.5942 25 19V11C25 8.40579 22.6219 6 20 6ZM8 11C8 9.3212 9.3033 8 11 8H20C21.6967 8 23 9.3212 23 11V19C23 20.6788 21.6967 22 20 22H11C9.3033 22 8 20.6788 8 19V11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C18.4807 20 20 17.4818 20 15C20 12.5182 18.4818 11 16 11C13.5182 11 11 12.5182 11 15C11 17.4818 13.5182 20 16 20ZM16 13C17.5405 13 18 14.4595 18 16C18 17.5405 17.5405 18 16 18C14.4595 18 13 17.5405 13 16C13 14.4595 14.4595 13 16 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20.5509 11 21 10.5518 21 10C21 9.44815 20.5518 9 20 9C19.4482 9 19 9.44815 19 10C19 10.5518 19.4482 11 20 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.02759c9ce8ee203e59dd9fa69153e109.svg";
export { ForwardRef as ReactComponent };